export const base = `
  font-family: futura-pt, sans-serif;
  font-weight: normal;
`

export const bold = `
  font-family: futura-pt-bold, sans-serif;

  /* Default 700 for better styling when font-family is not loaded */
  font-weight: 700;
`

const demi = `
  font-family: futura-pt, sans-serif;
  font-weight: 600;
  font-style: normal;
`

export const heading = bold

export default {
  base,
  bold,
  demi,
  heading,
}
